import React from 'react'
import styled from 'styled-components'
import { Modal, TextInput, Button } from 'advenio-components'
import { Form } from 'formsy-react' // eslint-disable-line

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
`

const ApplyLabel = styled.div`
  margin: 16px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
`
const ApplyModal = props => (
  <Modal
    isOpened={props.open}
    onClose={props.onClose}
    headerTitle={props.apply ? 'Aplicar Medicamento' : 'No aplicar medicamento'}
  >
    <Container>
      {props.apply ? (<Form onSubmit={props.submitApply}>
        <ApplyLabel>
          ¿Seguro que deseas aplicar el medicamento?
        </ApplyLabel>
        <ButtonContainer>
          <Button
            onClick={props.onClose}
          >
            Cancelar
          </Button>
          <Button
            primary
            type="submit"
          >
            Aplicar
          </Button>
        </ButtonContainer>
      </Form>) :
        (<Form onSubmit={props.submitApply}>
          <TextInput
            textarea
            label="Motivo"
            name="comments"
          />
          <ButtonContainer>
            <Button
              onClick={props.onClose}
            >
              Cancelar
            </Button>
            <Button
              danger
              type="submit"
            >
              No Aplicar
            </Button>
          </ButtonContainer>
        </Form>)}

    </Container>
  </Modal>
)

export default ApplyModal



// WEBPACK FOOTER //
// ./src/Containers/Medicine/ApplyModal.jsx